import styled from 'styled-components';
import { WhiteButton } from '../../../baseComponents/button';
import { FlexibleTextPartial } from '../../../partials/flexibleText';
import { TypographyStyles, colours, media, spacing } from '../../../stylings';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS};
  max-width: 857px;

  @media ${media.greaterThan('lg')} {
    gap: ${spacing.M};

    &.mini-cart-empty-basket {
      gap: ${spacing.XS};
    }
  }
`;
export const TextBlock = styled.div`
  background-color: ${colours.LIGHT_GREY_2};
  padding: 20px;
`;
export const Title = styled(FlexibleTextPartial)`
  display: block;
  margin: 0;
  margin-bottom: ${spacing.XXXS};
`;
export const Paragraph = styled(FlexibleTextPartial)`
  display: block;
  margin: 0;
`;
export const Button = styled(WhiteButton)`
  ${TypographyStyles.Button.SemiBold}
  align-items: center;
  background-color: transparent;
  border: 1px solid ${colours.DARK_BLUE};
  color: ${colours.DARK_BLUE};
  display: flex;
  height: 48px;
  justify-content: center;
  max-width: 375px;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
`;
